import React, { useEffect, useRef } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DealStep } from '../models/shared/DealStep';
import { Form } from 'react-bootstrap';
import { useText } from '../context/TextContext';
import { AdvancedButton } from './AdvancedButton';
import { DEFAULT_STEP_COLOR } from '../utils/shared/constants';

interface Props {
    step: DealStep;
    onUpdate: (id: string, update: Partial<DealStep>) => void;
    onRemove: (id: string) => void;
    focus?: boolean;
}

const PipelineStepEdit: React.FC<Props> = ({ step, onUpdate, onRemove, focus }) => {
    const text = useText();
    const inputRef = useRef<HTMLInputElement>(null);
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: step.id,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        backgroundColor: step.color || DEFAULT_STEP_COLOR
    };

    useEffect(() => {
        if (focus && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [focus]);

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}
            className="col p-3 border rounded shadow d-flex flex-column  gap-3"
        >
            <div className="d-flex align-items-center gap-2">
                <div {...listeners} className="bi bi-grip-vertical text-secondary cursor-move"></div>
                <Form.Control
                    ref={inputRef}
                    type="text"
                    value={step.name || ''}
                    onChange={(e) => onUpdate(step.id, { name: e.target.value })}
                />
            </div>

            <div className="d-flex align-items-center gap-2">
                <Form.Control
                    type="color"
                    value={step.color || '#E7D9C9'}
                    onChange={(e) => onUpdate(step.id, { color: e.target.value })}
                    title={text.chooseColor}
                />
                <Form.Label className="mb-0">{text.backgroundColor}</Form.Label>
            </div>

            <div className='mt-auto'>
                <hr />
                <div className='center'>
                    <AdvancedButton icon="bi-trash"
                        onClick={() => onRemove(step.id)}
                        size='sm' variant='secondary'>
                        {text.removeStep}
                    </AdvancedButton>
                </div>
            </div>
        </div>
    );
};

export default PipelineStepEdit;
